import { PageContainer } from "../../components/PageComponents";
import { Report } from "./Report";

const Dashboard = () => {
  return (
    <PageContainer title="Reports and Analytics">
      <Report />
    </PageContainer>
  );
};

export default Dashboard;
